import React from 'react'
import Particles from 'react-particles-js'
import Scroll from 'react-scroll'
import Slider from 'react-slick'
import ContactForm from '../components/contactform'
import Helmet from 'react-helmet'
import Header from '../components/header'

import logoWhite from '../img/logo-white.png'
import pipeDreamExtreme from '../img/feature-graphics/Pipe Dream Extreme.jpg'
import pipeDream from '../img/feature-graphics/Pipe Dream.jpg'
import runPaperScissors from '../img/feature-graphics/Run Paper Scissors.png'
import workPipeDreamExtreme from '../img/work/Pipe Dream Extreme.png'
import workPipeDream from '../img/work/Pipe Dream.png'
import workRunPaperScissors from '../img/work/Run Paper Scissors.png'

export default () => (
  <div>
		<Helmet
      title="Savage Squid Inc. | We Make Games"
      meta={[
        { name: 'description', content: 'Games' },
        { name: 'keywords', content: 'games, games' },
      ]}
    />
    <Header />
    <div className="jumbotron jumbotron-main" id="home">
      <Particles className="particles-js" params={{
        "particles": {
          "number": {
            "value": 80,
            "density": {
              "enable": true,
              "value_area": 800
            }
          },
          "color": {
            "value": "#ffffff"
          },
          "shape": {
            "type": "circle",
            "stroke": {
              "width": 0,
              "color": "#000000"
            },
            "polygon": {
              "nb_sides": 5
            },
            "image": {
              "src": "img/github.svg",
              "width": 100,
              "height": 100
            }
          },
          "opacity": {
            "value": 0.5,
            "random": false,
            "anim": {
              "enable": false,
              "speed": 1,
              "opacity_min": 0.1,
              "sync": false
            }
          },
          "size": {
            "value": 3,
            "random": true,
            "anim": {
              "enable": false,
              "speed": 40,
              "size_min": 0.1,
              "sync": false
            }
          },
          "line_linked": {
            "enable": true,
            "distance": 150,
            "color": "#ffffff",
            "opacity": 0.4,
            "width": 1
          },
          "move": {
            "enable": true,
            "speed": 6,
            "direction": "none",
            "random": false,
            "straight": false,
            "out_mode": "out",
            "bounce": false,
            "attract": {
              "enable": false,
              "rotateX": 600,
              "rotateY": 1200
            }
          }
        },
        "interactivity": {
          "detect_on": "canvas",
          "events": {
            "onhover": {
              "enable": true,
              "mode": "grab"
            },
            "onclick": {
              "enable": true,
              "mode": "push"
            },
            "resize": true
          },
          "modes": {
            "grab": {
              "distance": 140,
              "line_linked": {
                "opacity": 1
              }
            },
            "bubble": {
              "distance": 400,
              "size": 40,
              "duration": 2,
              "opacity": 8,
              "speed": 3
            },
            "repulse": {
              "distance": 200,
              "duration": 0.4
            },
            "push": {
              "particles_nb": 4
            },
            "remove": {
              "particles_nb": 2
            }
          }
        },
        "retina_detect": true
      }} />

      <div className="container" style={{paddingTop: '50px', color: '#fff'}}>
            <div className="col-sm-8 col-sm-offset-2 col-lg-6 col-lg-offset-3 text-center">
              <h1>
                <img src={logoWhite} height="200" />
              </h1>
              <hr />
              <p>We make games
                <br />
                <span className="ion-ios-game-controller-a"></span>
                <br />And <span className="ion-heart"></span> doing it.</p><br />
              <Scroll.Link to="about" spy={true} smooth={true} style={{color: '#fff', cursor: 'pointer'}}>
                  <span className="ion-mouse"></span>
                  <br />
                  <span className="ion-android-arrow-down arrow-scroll-indicator"></span>
              </Scroll.Link>
            </div>
        </div>
      </div>

      <Scroll.Element name="about" />
      <div id="hello-intro" className="pt60 pb60">
        <div className="container">
          <div className="row">
            <div className="col-lg-2 col-sm-3">
              <h2 className="no-margin rotateLeftReveal">Hello.</h2>
            </div>
            <div className="col-lg-10 col-sm-9 mt30-xs">
              <h3 className="no-margin rightReveal">We are a software development company with a focus on video game design and development. Our team is based in VA and
                <strong> we've been delivering quality pixels for years</strong>.</h3>
            </div>
          </div>
        </div>
      </div>
      <div id="our-process-title" className="pt30 pb30">
				<div className="container">
					<div className="row">
						<div className="col-lg-12 text-center">
							<h4 className="no-margin">About Us</h4>
						</div>
					</div>
				</div>
			</div>
      <div className="container section-padding">

						<div className="row mb15">
							<div className="col-sm-5 leftReveal">
								<h5 className="heading-1 mb20">Our Trade</h5>
								<h3 className="mb15 no-margin-top"><strong>Mobile Game Development</strong></h3>
								<p className="no-margin text-small">When developing a company, it's important to set reasonable goals. Most companies want to start out making AAA titles, whereas we just want to make fun games with a low iteration time.</p>
							</div>
							<div className="col-sm-7 mt30-xs rightReveal">
								<h5 className="heading-1 mb20">Our Mission</h5>
								<p>Our mission at Savage Squid is to craft fun, polished games that we love to play.  We believe that the best way to achieve this is to build a tight-knit, passionate team of talented developers — and then turn them loose to do what they do best.</p>

								<p>Great games start with great design, and everyone on our team contributes to making our games fun.  Our process is built on playtesting and iteration.  Refinement and polish.  We want you to love our games as much as we do.</p>
							</div>
						</div>
						<div className="row">
							<div className="col-lg-7 col-sm-5 bottomReveal">
								<h5 className="heading-1 mb20">Current Projects</h5>
								<div className="progress">
									<div className="progress-bar text-left" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100">
										Pipe Dream
									</div>
								</div>
								<div className="progress">
									<div className="progress-bar text-left" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
										Jacks Or Better
									</div>
								</div>
								<div className="progress">
									<div className="progress-bar text-left" role="progressbar" aria-valuenow="57" aria-valuemin="0" aria-valuemax="100">
										Run Paper Scissors
									</div>
								</div>
								<div className="progress">
									<div className="progress-bar text-left" role="progressbar" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100">
										Pipe Dream Extreme
									</div>
								</div>
								<div className="progress">
									<div className="progress-bar text-left" role="progressbar" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100">
										Double Joker Poker
									</div>
								</div>
								<div className="progress">
									<div className="progress-bar text-left" role="progressbar" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100">
										Deuces Wild Poker
									</div>
								</div>
								<div className="progress-meter mb30-xs">
									<div className="meter meter-left" style={{width: '20%'}}>
										<span className="meter-text">Planning</span>
									</div>
									<div className="meter meter-left" style={{width: '40%'}}>
										<span className="meter-text">Development</span>
									</div>
									<div className="meter meter-right" style={{width: '20%'}}>
										<span className="meter-text">Publishing</span>
									</div>
									<div className="meter meter-right" style={{width: '20%'}}>
										<span className="meter-text">Testing</span>
									</div>
								</div>
							</div>
							<div className="col-lg-5 col-sm-7 mt10 rotateLeftReveal">
                <Slider arrows={false} dots={true} infinite={true} speed={500} slidesToShow={1} slidesToScrll={1}>
                  <div><img src={pipeDreamExtreme} alt="Pipe Dream Extreme" className="img-responsive" /></div>
                  <div><img src={runPaperScissors} alt="Run Paper Scissors" className="img-responsive" /></div>
                  <div><img src={pipeDream} alt="Pipe Dream" className="img-responsive" /></div>
                </Slider>
                {/*
								<div id="about-carousel" className="basic-carousel carousel slide" data-ride="carousel">
									<ol className="carousel-indicators">
										<li data-target="#about-carousel" data-slide-to="0" className="active"></li>
										<li data-target="#about-carousel" data-slide-to="1"></li>
										<li data-target="#about-carousel" data-slide-to="2"></li>
									</ol>

									<div className="carousel-inner" role="listbox">
										<div className="item active">
											<img src="/static/img/feature-graphics/Pipe Dream Extreme.jpg" alt="Pipe Dream Extreme" className="img-responsive" />
										</div>
										<div className="item">
											<img src="/static/img/feature-graphics/Run Paper Scissors.png" alt="Run Paper Scissors" className="img-responsive" />
										</div>
										<div className="item">
											<img src="/static/img/feature-graphics/Pipe Dream.jpg" alt="Pipe Dream" className="img-responsive" />
										</div>
									</div>
                </div>
                */}
							</div>
						</div>
			</div>

      <section id="work" className="background1 section-padding-top">
			<div className="container-fluid">
				<div className="row">
					<div className="col-xs-12 section-title text-center">
						<h2>Work</h2>
						<span className="section-divider mb15"></span>
						<p className="mb30 scaleReveal">We do some pretty awesome stuff.</p>
					</div>
				</div>
        <div id="thework">
					<div className="col-xs-12 col-sm-6 col-md-4 col-lg-4 portfolio-box no-padding 2dmobile" data-my-order="3">
						<div className="portfolio-image-holder">
							<img src={workPipeDreamExtreme} alt="Pipe Dream Extreme" className="img-responsive portfolio-image" />
						</div>
						<span className="portfolio-badge badge">2D Mobile Game</span>
						<span className="portfolio-hover">
							<span>
								<a href="https://itunes.apple.com/us/app/pipe-dream-extreme/id1216832746?ls=1&mt=8" target="_blank">
									<span className="portfolio-links">
										<span className="ion-social-apple portfolio-links-icons"></span>
									</span>
								</a> &nbsp;
								<a href="https://play.google.com/store/apps/details?id=com.savagesquid.pipedreamextreme" target="_blank">
									<span className="portfolio-links">
										<span className="ion-social-android portfolio-links-icons"></span>
									</span>
								</a>
								<span className="project-title no-margin-bottom mt10">Pipe Dream Extreme</span>
							</span>
						</span>
					</div>

					<div className="col-xs-12 col-sm-6 col-md-4 col-lg-4 portfolio-box no-padding 2dmobile" data-my-order="3">
							<div className="portfolio-image-holder">
								<img src={workRunPaperScissors} alt="Run Paper Scissors" className="img-responsive portfolio-image" />
							</div>
							<span className="portfolio-badge badge">2D Mobile Game</span>
							<span className="portfolio-hover">
								<span>
									<a href="https://itunes.apple.com/us/app/run-paper-scissors/id1288662253?ls=1&mt=8" target="_blank">
										<span className="portfolio-links">
											<span className="ion-social-apple portfolio-links-icons"></span>
										</span>
									</a> &nbsp;
									<a href="https://play.google.com/store/apps/details?id=com.savagesquid.runpaperscissors" target="_blank">
										<span className="portfolio-links">
											<span className="ion-social-android portfolio-links-icons"></span>
										</span>
									</a>
									<span className="project-title no-margin-bottom mt10">Run Paper Scissors</span>
								</span>
							</span>
						</div>

					<div className="col-xs-12 col-sm-6 col-md-4 col-lg-4 portfolio-box no-padding 2dmobile" data-my-order="3">
							<div className="portfolio-image-holder">
								<img src={workPipeDream} alt="Pipe Dream" className="img-responsive portfolio-image" />
							</div>
							<span className="portfolio-badge badge">2D Mobile Game</span>
							<span className="portfolio-hover">
								<span>
									<a href="https://itunes.apple.com/us/app/pipe-dream/id1214727602?ls=1&mt=8" target="_blank">
										<span className="portfolio-links">
											<span className="ion-social-apple portfolio-links-icons"></span>
										</span>
									</a> &nbsp;
									<a href="https://play.google.com/store/apps/details?id=com.savagesquid.pipedream" target="_blank">
										<span className="portfolio-links">
											<span className="ion-social-android portfolio-links-icons"></span>
										</span>
									</a>
									<span className="project-title no-margin-bottom mt10">Pipe Dream</span>
								</span>
							</span>
						</div>

				</div>
			</div>
		</section>

    <section id="contact" className="background2 section-padding">
			<div className="container">
				<div className="row mb30">
					<div className="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3 section-title text-center">
						<h2>Contact</h2>
						<span className="section-divider mb15"></span>
						<p className="no-margin scaleReveal">We'd love to hear from you</p>
					</div>
				</div>
				<div className="row">
					<div className="col-sm-5 col-lg-4">
						<h5 className="heading-1 mb20">The Manual Way</h5>
						<p className="text-xs-small mb5">
							<strong className="text-switch">Email:</strong> info@savagesquid.com</p>
					</div>
					<div className="col-sm-6 col-lg-7 mt30-xs">
						<ContactForm />
					</div>
				</div>
			</div>
		</section>


    <footer className="footer-padding">
			<div className="container">
				<div className="row">
					<div className="col-sm-8 col-sm-offset-2 text-center">
						<span className="icon-handle-streamline-vector logo"></span>
						<h2 className="theme-title">Savage Squid
							<span className="theme-title-smaller">Inc.</span>
						</h2>
					</div>
				</div>
				<div className="row">
					<div className="col-sm-8 col-sm-offset-2 text-small text-center">
						<hr />
						<button type="button" className="btn btn-primary btn-up-footer btn-lg scroll-top" onClick={Scroll.animateScroll.scrollToTop}>Up</button>
						<p className="no-margin">2018 &copy; Savage Squid Inc.</p>
					</div>
				</div>
			</div>
		</footer>

  </div>
)



// WEBPACK FOOTER //
// ./src/pages/index.js